import React from "react";
import "../../styles/LocationsInIndia.css";
import locationsImage from "../../images/locations-slider.jpg"; // Update with correct image path

const LocationsInIndia = () => {
  return (
    <div className="locations-container">
      {/* Image Slider */}
      <div className="image-slider">
        <img src={locationsImage} alt="Locations in India Slider" />
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63090KA1997PTC022102</p>
            <p>
              <a href="/privacy-statement" className="footer-link">
                Privacy Statement
              </a>{" "}
              |{" "}
              <a href="/terms-of-use" className="footer-link">
                Terms Of Use
              </a>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p>
              <strong>Registered Office</strong>
            </p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LocationsInIndia;
